module.exports = __webpack_public_path__ + "static/media/grow-green.96ecd539.jpg";